export default __webpack_public_path__ + "static/media/lr.d92153e5.svg";